import {
    fetchProductTopList,
    fetchProductDeliveryWeeks,
} from '../actions/routines';
import { call, put } from 'redux-saga/effects';
import Products from '../services/api/Products';

export function* fetchProductTopListSaga() {
    try {
        yield put(fetchProductTopList.request());

        const response = yield call(Products.getTopList);

        yield put(fetchProductTopList.success(response.data));

        // fetch delivery
        if (response.data && response.data.length > 0) {
            const productIds = response.data.map((product) => product.id);
            yield put(fetchProductDeliveryWeeks({ productIds }));
        }
    } catch (error) {
        yield put(fetchProductTopList.failure(error.message));
    } finally {
        yield put(fetchProductTopList.fulfill());
    }
}
